module.exports = __webpack_public_path__ + "img/checked2.c7ab8ca0.png";